import ReactLoading from "react-loading";
import Backdrop from "@mui/material/Backdrop";
// import Redux
import {  useSelector } from 'react-redux';
import { RootState } from '../store/reducers';

import React from 'react'

const ApiLoad = (props:any) => {
  const {load} = props
  const state = useSelector((state: RootState) => state.waiter)
  return (
    <Backdrop
    sx={{ color: "#fff", zIndex: (theme:any) => theme.zIndex.drawer + 5 }}
    open={load} >
      <ReactLoading className="mx-auto" type="spin" color="#00000" />
    </Backdrop>
  )
}

export default ApiLoad